import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

interface SortIconProps {
  active: boolean;
  direction?: 'asc' | 'desc' | '' | undefined;
}

export function SortIcon({ active, direction }: SortIconProps) {
  if (!active || !direction || direction === '') {
    return <ArrowUpDown className="w-4 h-4 ml-2 text-gray-400" />;
  }
  return direction === 'asc' ? (
    <ArrowUp className="w-4 h-4 ml-2 text-blue-500" />
  ) : (
    <ArrowDown className="w-4 h-4 ml-2 text-blue-500" />
  );
}
